import { notifications } from '@mantine/notifications';
import {
  transactionCategoryKeys,
  useGetTransactionCategory,
  useUpdateTransactionCategory,
} from 'api-hooks/transaction-category';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import TransactionCategoryForm from './components/form';

export default function TransactionCategoryView() {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetTransactionCategory({ id }, { enabled: !!id });
  const updateMutation = useUpdateTransactionCategory();

  return (
    <TransactionCategoryForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          id,
        });
        queryClient.refetchQueries(transactionCategoryKeys.index());
        queryClient.refetchQueries(transactionCategoryKeys.view({ id }));
        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
